import React, { useRef, useState } from 'react';
import { jsonResponseHandler } from '../../utils/FetchHelper'
import TSelect from '../common/TSelect';
import TButton from '../common/TButton';
import Photos from '../../lib/Photos'
import { useDispatch } from "react-redux";
import {addPrefix} from "../../utils/UriUtil";
import {TISTORY} from "../../constants/Service"

function UseMobileWebForm({setting, onChange}) {
  return (
    <>
      <div className="item_set">
        티스토리 모바일웹 자동 연결을
        <TSelect
          defaultClassName={'opt_set opt_mobile1'}
          selectItem={onChange}
          propertyName={"useMobileSkin"}
          selected={setting} optionList={{
            useMobileSkin: [
              {name: "use", label: "사용합니다.", value: 1},
              {name: "notUse", label: "사용하지 않습니다.", value: 0}
            ]
          }}
        />
      </div>
      <p className="txt_info">
        사용 시 모바일에서 접속 시 자동으로 모바일웹으로 전환되며, 사용하지 않아도 직접 모바일 주소로 접속할 경우 모바일웹으로 접속됩니다.
      </p>
    </>
  )
}

function MobileImageForm({setting, data, onChange}) {

  const dispatch = useDispatch()
  const titleBgImg = useRef(null)
  const { title, description, ownerName } = data

  function handleRemoveTitleBgImg() {
    if (confirm('이미지를 삭제하시겠습니까?')) {
      onChange('')
    }
  }

  function handleUploadTitleBgImg(e) {
    const files = e.target.files
    if (files.length === 0) {
      return
    }

    uploadTitleBgImg(files[0])
      .then(url => {
        Photos.getInstance().open(url, uploadTitleBgImg)
      })
  }

  function uploadTitleBgImg(file) {
    let formdata = new FormData();
    formdata.append("files[]", file, file.name);

    const originTitleBgImg = setting.titleBgImg;
    onChange('loading');

    return fetch(addPrefix("/manage/design/mobile/titleBgImg.json"), {
      method: 'post',
      credentials: "include",
      body: formdata
    })
      .then(jsonResponseHandler(dispatch))
      .then(r => r.json())
      .then(data => {
        onChange(data.url);
        titleBgImg.current.value = '';
        return data.url;
      })
      .catch(e => {
        console.error(e)
        titleBgImg.current.value = ''
        onChange(originTitleBgImg)
      })
  }

  const previewSrc = addPrefix(`/manage/previewMobile.php?title_bg_image=${encodeURIComponent(setting.titleBgImg)}&blog_title=${title}&blog_subtitle=${description}&blog_by=${ownerName}`);
  return (
    <div className="wrap_iframe">
      <iframe width="360" height="579" frameBorder="0" marginWidth="0" marginHeight="0" scrolling="no" title="모바일웹 스킨 미리보기" src={previewSrc} />

      <div className="photo_profile">
        <label className="lab_btn lab_photo">
          <span className="ico_blog">블로그 이미지 찾아보기</span>
          <input ref={titleBgImg} type="file" className="btn_g" onChange={handleUploadTitleBgImg} />
        </label>
        {setting.titleBgImg !== '' &&
          <button type="button" className="btn_delete" onClick={handleRemoveTitleBgImg} >이미지 삭제</button>
        }
      </div>
    </div>
  )
}


export default function MobileForm({data}) {

  const dispatch = useDispatch()

  const [initialSetting, setInitialSetting] = useState({
    useMobileSkin: data.useMobileSkin,
    titleBgImg: data.titleBgImg,
  })

  const [setting, setSetting] = useState({
    useMobileSkin: data.useMobileSkin,
    titleBgImg: data.titleBgImg,
  })
  const [changed, setChanged] = useState({})


  function changeSelection(property, value) {
    let diff = {};
    diff[property] = value;

    setSetting(Object.assign({}, setting, diff))
    setChanged(Object.assign({}, changed, diff))
  }

  function setTitleBgImg(url) {
    setSetting(Object.assign({}, setting, {
      titleBgImg: url
    }))
  }

  function handleSave(callback, failCallback){
    fetch(addPrefix("/manage/design/mobile"),
      {
        method: 'put',
        credentials: 'include',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify(setting)
      })
      .then(jsonResponseHandler(dispatch))
      .then(r => r.json())
      .then(data => {
        callback();
        setInitialSetting(setting)
      })
      .catch(e => {
        console.log(e);
        failCallback();
      });
  }

  return (
    <form className="wrap_set">
      <fieldset className="fld_image">
        <legend className="screen_out">모바일 이미지 설정</legend>
        {window.Config.service === TISTORY && <UseMobileWebForm onChange={changeSelection} setting={setting} />}
        <MobileImageForm onChange={setTitleBgImg} setting={setting} data={data} />
      </fieldset>
      <fieldset>
        <legend className="screen_out">저장 버튼</legend>
        <TButton onClick={handleSave} initialValues={initialSetting} currentValues={setting}/>
      </fieldset>
    </form>
  )
}
